import numeral from 'numeral';
import 'numeral/locales/es-es';
numeral.locale('es-es');
export default numeral;
